import { z } from "zod";
/**
 * Personal all-time activity counts for the Community You tab's "Your
 * activity" grid. Caller-scoped only (own data); counts cover the member's
 * full history, not a rolling window. Day streak is not here: it comes from
 * GET /api/plan/activity (microstep completion streak).
 */
export const GetCommunityMeStatsResponse = z.object({
    momentsShared: z.number().int().nonnegative(),
    reactionsGiven: z.number().int().nonnegative(),
    kudosSent: z.number().int().nonnegative(),
});
//# sourceMappingURL=me-stats.js.map